export default defineNuxtPlugin(() => {
  if (process.client) {
    // Vanta.js will be loaded dynamically in the component
    return {
      provide: {
        vanta: () => {
          if (typeof window !== 'undefined' && window.VANTA) {
            return window.VANTA
          }
          return null
        }
      }
    }
  }
})
